
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      guidelines: {
        Row: {
          id: string;
          title: string;
          description: string;
          agency: 'Fannie Mae' | 'Freddie Mac' | 'HUD' | 'VA';
          category: string;
          tags: string[];
          content: string | null;
          source_url: string | null;
          effective_date: string | null;
          last_updated: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          title: string;
          description: string;
          agency: 'Fannie Mae' | 'Freddie Mac' | 'HUD' | 'VA';
          category: string;
          tags?: string[];
          content?: string | null;
          source_url?: string | null;
          effective_date?: string | null;
          last_updated?: string;
          created_at?: string;
        };
        Update: {
          id?: string;
          title?: string;
          description?: string;
          agency?: 'Fannie Mae' | 'Freddie Mac' | 'HUD' | 'VA';
          category?: string;
          tags?: string[];
          content?: string | null;
          source_url?: string | null;
          effective_date?: string | null;
          last_updated?: string;
          created_at?: string;
        };
      };
      profiles: {
        Row: {
          id: string;
          first_name: string | null;
          last_name: string | null;
          company: string | null;
          role: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          first_name?: string | null;
          last_name?: string | null;
          company?: string | null;
          role?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          first_name?: string | null;
          last_name?: string | null;
          company?: string | null;
          role?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      user_bookmarks: {
        Row: {
          id: string;
          user_id: string;
          guideline_id: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          guideline_id: string;
          created_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          guideline_id?: string;
          created_at?: string;
        };
      };
    };
  };
};
